<div class="todo-page">
  <div class="header">
    <div>
      <p class="eyebrow">My Tasks</p>
      <h2>Project Todo</h2>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select [(value)]="status" (selectionChange)="load()">
        <mat-option value="all">All</mat-option>
        <mat-option value="Pending">Pending</mat-option>
        <mat-option value="In Progress">In Progress</mat-option>
        <mat-option value="Blocked">Blocked</mat-option>
        <mat-option value="Done">Done</mat-option>
        <mat-option value="Completed">Completed</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="task-list" *ngIf="tasks.length; else empty">
    <div class="task-card" *ngFor="let t of tasks">
      <div class="top">
        <div>
          <p class="eyebrow">{{ t.projectName || 'Project' }}</p>
          <h3>{{ t.title }}</h3>
        </div>
        <span class="chip" [ngClass]="statusClass(t)">{{ t.status }}</span>
      </div>
      <p class="desc">{{ t.description || 'No description' }}</p>
      <div class="progress">
        <div class="bar">
          <div class="fill" [style.width.%]="progressWidth(t)"></div>
        </div>
        <span>{{ t.progressPercent | number:'1.0-0' }}%</span>
      </div>
      <div class="meta">
        <span>Due: {{ t.dueDate ? (t.dueDate | date:'mediumDate') : '—' }}</span>
        <span>Assignee: {{ t.assignedStaffName || '-' }}</span>
        <span>Owner: {{ t.createdByName || '-' }}</span>
        <span>Updated: {{ t.updatedAt | date:'short' }}</span>
      </div>

      <div class="updates">
        <div class="updates-head">
          <strong>Comment Updates</strong>
          <span>{{ t.commentCount || 0 }} posted</span>
        </div>

        <div class="comment-list" *ngIf="t.comments?.length; else noTaskComments">
          <div class="comment-item" *ngFor="let comment of t.comments">
            <div class="comment-meta">
              <strong>{{ comment.createdByStaffName || comment.createdByName || 'Team member' }}</strong>
              <span>{{ comment.createdAt | date:'short' }}</span>
            </div>
            <p>{{ comment.comment }}</p>
            <div class="inline-media" *ngIf="comment.mediaAttachments?.length">
              <button type="button" class="preview-link" *ngFor="let media of comment.mediaAttachments" (click)="openPreview(media)">{{ media.fileName }}</button>
            </div>
            <button mat-button type="button" (click)="setReplyTarget(t.id, comment.id)">Reply</button>
            <div class="reply-list" *ngIf="comment.replies?.length">
              <div class="reply-item" *ngFor="let reply of comment.replies">
                <div class="comment-meta">
                  <strong>{{ reply.createdByStaffName || reply.createdByName || 'Team member' }}</strong>
                  <span>{{ reply.createdAt | date:'short' }}</span>
                </div>
                <p>{{ reply.comment }}</p>
                <div class="inline-media" *ngIf="reply.mediaAttachments?.length">
                  <button type="button" class="preview-link" *ngFor="let media of reply.mediaAttachments" (click)="openPreview(media)">{{ media.fileName }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-template #noTaskComments>
          <div class="empty-comments">No updates yet. Use comments for progress notes and blockers.</div>
        </ng-template>

        <div class="comment-form">
          <div class="reply-target" *ngIf="replyTargets[t.id]">
            Replying to comment #{{ replyTargets[t.id] }}
            <button mat-button type="button" (click)="setReplyTarget(t.id, null)">Cancel</button>
          </div>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Add your update</mat-label>
            <textarea #todoCommentInput matInput rows="3" [(ngModel)]="commentDrafts[t.id]" placeholder="Share progress, blocker, or completion note." (input)="onCommentInput(t.id, $event)" (click)="onCommentInput(t.id, $event)"></textarea>
          </mat-form-field>
          <div class="mention-box full-width" *ngIf="mentionSuggestions(t.id).length">
            <button type="button" class="mention-option" *ngFor="let staff of mentionSuggestions(t.id)" (click)="insertCommentMention(t.id, staff, todoCommentInput)">
              <strong>{{ staff.fullName }}</strong>
              <span>{{ staff.position || 'Staff' }}</span>
            </button>
          </div>
          <input #todoCommentFileInput type="file" multiple accept="image/*,video/*,audio/*,application/pdf" (change)="onCommentMediaSelected(t.id, $event)" hidden />
          <button type="button" class="dropzone" (click)="todoCommentFileInput.click()" (dragover)="$event.preventDefault()" (drop)="onCommentMediaDrop(t.id, $event)">
            <strong>Drop comment media here</strong>
            <span>or click to choose files</span>
          </button>
          <div class="pending-media" *ngIf="commentAttachments[t.id]?.length">
            <div class="pending-media-item" *ngFor="let media of commentAttachments[t.id]; let i = index">
              <button type="button" class="preview-link" (click)="openPreview(media)">{{ media.fileName }}</button>
              <button mat-button type="button" (click)="removeCommentMedia(t.id, i)">Remove</button>
            </div>
          </div>
          <button mat-flat-button color="primary" (click)="addComment(t)" [disabled]="postingCommentFor === t.id">
            {{ postingCommentFor === t.id ? 'Posting...' : 'Post Update' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template #empty>
    <div class="empty">No tasks assigned.</div>
  </ng-template>

  <section class="preview-panel" *ngIf="previewMedia as media">
    <div class="updates-head">
      <strong>{{ media.fileName }}</strong>
      <div class="preview-actions">
        <a mat-stroked-button [href]="media.url" target="_blank" rel="noopener">Open in New Tab</a>
        <button mat-stroked-button type="button" (click)="closePreview()">Close</button>
      </div>
    </div>
    <div class="preview-stage" [ngSwitch]="mediaKind(media.url, media.contentType)">
      <img *ngSwitchCase="'image'" [src]="media.url" [alt]="media.fileName" />
      <video *ngSwitchCase="'video'" [src]="media.url" controls></video>
      <audio *ngSwitchCase="'audio'" [src]="media.url" controls></audio>
      <object *ngSwitchCase="'pdf'" [data]="media.url" type="application/pdf" width="100%" height="520"></object>
      <div *ngSwitchDefault class="preview-fallback">Preview is not available for this file type. Use “Open in New Tab”.</div>
    </div>
  </section>
</div>
